function indexOf(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return null
  if (!/^\d+$/.test(String(value))) return null
  const index = Number(value)
  return Number.isSafeInteger(index) ? index : null
}

function hasError(value, depth = 0) {
  if (depth > 6 || value == null) return false
  if (typeof value === 'string') return value.trim().length > 0
  return typeof value === 'object' && Object.values(value).some(item => hasError(item, depth + 1))
}

function guidance(rule, ruleIndex, optionIndex) {
  const position = rule.option?.[0] === 'position'
  let message
  if (optionIndex === 0) message = '일부 남기기 조건을 다시 선택해 주세요.'
  else if (optionIndex === 1) message = position
    ? '글자 수는 0 이상의 정수로 입력해 주세요.'
    : '글자 수를 정수로 입력해 주세요.'
  else if (optionIndex === 2 && position) message = '시작 위치는 1 이상의 정수로 입력해 주세요.'
  else message = position
    ? '일부 남기기의 조건, 글자 수와 시작 위치를 확인해 주세요.'
    : '일부 남기기의 조건과 글자 수를 확인해 주세요.'
  return `${ruleIndex + 1}번 규칙: ${message}`
}

export function getReplaceKeepErrorMessage(payload, request = {}) {
  // 1007029 is also used by other conversions and trim_chars. Scope by API AND rule.
  if (!/(?:^|\/)annotation\/(?:make|get)-replace\/?(?:[?#]|$)/.test(request.url || '')) return ''
  if (!payload || typeof payload !== 'object') return ''
  let body = request.data
  if (typeof body === 'string') {
    try { body = JSON.parse(body) } catch { return '' }
  }
  if (!Array.isArray(body?.rules)) return ''
  const rules = body.rules

  if (payload.err_code != null) {
    if (!['1007028', '1007029'].includes(String(payload.err_code))) return ''
    const ruleIndex = indexOf(payload.rule_index)
    if (ruleIndex === null || rules[ruleIndex]?.type !== 'keep') return ''
    return guidance(rules[ruleIndex], ruleIndex, indexOf(payload.option_index))
  }

  // DRF ListField errors can be index-keyed objects; array-shaped errors are also accepted.
  if (!payload.rules || typeof payload.rules !== 'object') return ''
  for (const [key, errors] of Object.entries(payload.rules)) {
    const ruleIndex = indexOf(key)
    if (ruleIndex === null || rules[ruleIndex]?.type !== 'keep' || !hasError(errors?.option)) continue
    const option = errors.option
    if (option && typeof option === 'object' && !Object.values(option).some(value => typeof value === 'string')) {
      for (const [optionKey, value] of Object.entries(option)) {
        const optionIndex = indexOf(optionKey)
        if (optionIndex !== null && hasError(value)) return guidance(rules[ruleIndex], ruleIndex, optionIndex)
      }
    }
    return guidance(rules[ruleIndex], ruleIndex, null)
  }
  return ''
}
